module.exports = __webpack_public_path__ + "static/media/working.82683119.svg";